<template>
    <div class="my-tickets-popup-wrapper">
        <MainHeaderButton
            class="main-header-button--tickets"
            :icon
            :badge
            :route="isMobile ? PATHS.MY_TICKETS : null"
            @click="myTicketsClick"
        >
            TIKETY
        </MainHeaderButton>
        <MyTicketsPopup v-if="!isMobile" v-model="popupOpen" />
    </div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, ref } from "vue";
import { useRouter } from "vue-router";
import MyTicketsPopup from "@/my-tickets/components/organisms/MyTicketsPopup.vue";
import MainHeaderButton from "@/header/components/atoms/MainHeaderButton.vue";
import useIsBreakpoint from "@/shared/composables/use-is-breakpoint";
import { PATHS } from "@/router/paths";
import { useBetsStore } from "@/shared/stores/use-bets-store";

const router = useRouter();

const { isMobile } = useIsBreakpoint();

const popupOpen = ref(false);

const myTicketsClick = () => {
    if (isMobile.value) return;

    popupOpen.value = !popupOpen.value;
};

const betsStore = useBetsStore();
const badge: ComputedRef<string> = computed(() => betsStore.openBetsCountText);
const icon = computed(() => {
    const routeIsActive = router.currentRoute.value.fullPath.includes(PATHS.MY_TICKETS);

    return routeIsActive ? "tickets-fill" : "tickets";
});
</script>
